import { Modal, SaveBar, TitleBar, useAppBridge } from '@shopify/app-bridge-react';
import { useEffect, useState } from 'react';

const ModalOnpageAI = ({
  onpagePubilsh,
  onpagePubilshLoading,
  handleModalCustomizeState,
  handleModalCustomizeData,
}) => {

  // Shopify 属性
  const shopify = useAppBridge();

  const [editState, setEditState] = useState(false); // 是否可以操作
  const [barState, setBarState] = useState(false);   // 是否显示了保存bar
  const [pubilshState, setPubilshState] = useState(true);   // 是否发布

  // 关闭弹窗
  const modalHideAction = () => {
    handleModalCustomizeState(false, "/on-page-seo", "OnpageAI_Modal");  // 回退指定页面
  }

  // 舍弃保存
  const handleDiscard = () => {
    if (editState) {
      shopify.saveBar.hide('SaveBarMax_OnpageAI');
      handleModalCustomizeData('discard', "OnpageAI_Modal");
      setBarState(false);
    }
  };

  // 内容保存
  const handleSave = () => {
    if (editState) {
      handleModalCustomizeData('save', "OnpageAI_Modal");
    }
  }

  // 发布博客
  const handlePublishBlog = () => {
    handleModalCustomizeData('publish', "OnpageAI_Modal");
  }

  // 接收子窗口
  const handleFromModalOnpageAI = (ev) => {
    const _that = ev.data;
    if (_that?.page === "Edit") {
      const _type = _that?.mode || '';
      if (_type === "save") {
        // 保存
        shopify.saveBar.hide('SaveBarMax_OnpageAI');
        setBarState(false);
      } else if (_type === "showSavebar") {
        // 隐藏发布
        setPubilshState(false);
        // 显示保存bar
        setEditState(true);
        // 判断是否显示了
        if (!barState) {
          shopify.saveBar.show("SaveBarMax_OnpageAI");
          setBarState(true);
        }
      } else if (_type === "hideSavebar") {
        shopify.saveBar.hide("SaveBarMax_OnpageAI");
        // 显示发布
        setPubilshState(true);
        setBarState(false);
      } else { }
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleFromModalOnpageAI)
    return () => {
      window.removeEventListener('message', handleFromModalOnpageAI)
    }
  }, [])

  // 弹窗模块
  return (
    <Modal id="OnpageAI_Modal" src={"/on-page-seo/detail"} variant={"max"} onHide={modalHideAction}>
      <TitleBar title={"SEOAnt - AI Optimize Content"}>
        {
          !onpagePubilsh && pubilshState ? <button variant="primary" onClick={handlePublishBlog} loading={onpagePubilshLoading ? "" : null}>{"Publish"}</button> : null
        }
      </TitleBar>
      <SaveBar id="SaveBarMax_OnpageAI" discardConfirmation="">
        <button onClick={handleDiscard}></button>
        <button variant="primary" onClick={handleSave}></button>
      </SaveBar>
    </Modal>
  )

}

export default ModalOnpageAI;